export default __webpack_public_path__ + "static/media/0013.f1dbbc99.jpg";